import { ADDRESS_BOOK_STORE } from '@constants/store'
import { LAST_ORDER_MODULE } from '../store/modules/lastOrderModule'
import { GENERAL_STORE } from '../store'

export default {
  methods: {
    /**
     * Установка начального состояния для точки забора. Данные из последнего заказа, адресной книги в подсказки для точек
     */
    async setDotsData() {
      // Проверякм подключены ли модули
      const hasLastOrderModule = this.$store.hasModule(LAST_ORDER_MODULE)
      const hasAddressBookModule = this.$store.hasModule(ADDRESS_BOOK_STORE)

      // Инициализация подсказок по последнему заказу, если модуль подключен
      if (hasLastOrderModule) {
        await this.$store.dispatch(`${LAST_ORDER_MODULE}/getLastOrderState`) // Получение подсказок и данных по ним
      }

      // Инициализация подсказок из адресной книги, если модуль подключен
      if (hasAddressBookModule) {
        await this.$store.dispatch(`${ADDRESS_BOOK_STORE}/getAddressBookState`) // Получение подсказок и данных по ним
      }

      // Если редактирование заказа - выходим
      if (this.$store.state[GENERAL_STORE].base.isEdit) return

      // Точка забора из последнего заказа
      const lastOrderPickupDot = hasLastOrderModule
        ? this.$store.getters[`${LAST_ORDER_MODULE}/lastOrderTemplate`]?.pickupDot
        : null

      // Точка забора из адресной книги
      const mainAddressInBook = hasAddressBookModule
        ? this.$store.getters[`${ADDRESS_BOOK_STORE}/mainAddress`]
        : null

      // Проверяем выбран ли основной адрес в адресной книге и он из выбранного города, если есть - подставляем его
      // иначе, если был заказ в выбранном городе - подставим точку забора
      if (mainAddressInBook)
        await this.$store.dispatch(`${ADDRESS_BOOK_STORE}/setPickupDotAddressItemState`)
      else if (lastOrderPickupDot)
        await this.$store.dispatch(`${LAST_ORDER_MODULE}/setLastOrderInitialState`)
    },
  },
}
